import { helper } from '@ember/component/helper';

export default helper(function toFixed(
  [value, decimal_points = 1] /*, named*/,
) {
  const castedValue = Number(value);
  if (isNaN(castedValue)) return null;
  return castedValue.toFixed(decimal_points);
});
